import { Flex, Heading, Link, List, Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Card } from "./Card";

import DOMPurify from "dompurify";
import * as Config from "../config/Config";
import { CourseCodeErrorService } from "../services/CourseCodeErrorService";
import { ERROR, useNotification } from "./CustomHooks/NotificationProvider";

export const CourseCodeError = () => {
  const { t } = useTranslation();
  const [files, setErrorFiles] = useState([]);
  const showNotification = useNotification();

  useEffect(() => {
    CourseCodeErrorService.getCourseCodeErrors().then((error_files) => {
      const files = [];
      error_files.forEach((file) => {
        files.push({
          name: file.file_name,
          path: file.file_path,
          key: file.file_key,
          datetime: file.file_datetime,
        });
      });
      setErrorFiles(files);
    });
  }, []);

  const downloadErrorFile = (fileKey, filePath, fileName) => {
    try {
      const errorFileUrl = Config.getDownloadErrorFileUrl(
        filePath,
        fileName,
        fileKey
      );
      const xhr = new XMLHttpRequest();
      xhr.open("GET", errorFileUrl, true);
      xhr.responseType = "text";
      xhr.withCredentials = true;
      xhr.onload = function () {
        const blob = new Blob([this.responseText], { type: "text/plain" });
        // Create a download link for the Blob
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName
          ? DOMPurify.sanitize(fileName)
          : "downloadedFile";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Release the object URL
        window.URL.revokeObjectURL(url);
      };
      xhr.send();
    } catch (e) {
      console.debug(e);
      showNotification(t("notifications.general.downloadError"), ERROR);
    }
  };

  return (
    <Card style={{ marginTop: 15 }}>
      <Heading as="h3" level="h4" margin="0 0 small 0" border="bottom">
        {t("courseCodePattern.courseCodeImportError")}
      </Heading>
      <List>
        {files.map((file, key) => (
          <List.Item key={key}>
            <Flex justifyItems="space-between" alignItems="start" wrap="wrap">
              <Flex.Item>
                <Text size="small" as="p">
                  <Link
                    href=""
                    onClick={() =>
                      downloadErrorFile(file.key, file.path, file.name)
                    }
                  >
                    {file.datetime}
                  </Link>{" "}
                </Text>
              </Flex.Item>
            </Flex>
          </List.Item>
        ))}
      </List>
    </Card>
  );
};
